import { CommonModule } from "@angular/common";
import { LaddaModule } from "angular2-ladda";
import { NgModule } from "@angular/core";
import { UploadButtonComponent } from "./upload-btn.component";
import { UploadButtonService } from "./upload-btn.service";

@NgModule({
  imports: [CommonModule, LaddaModule],
  declarations: [UploadButtonComponent],
  exports: [UploadButtonComponent],
  providers: [UploadButtonService]
})
export class UploadButtonModule {}
